import { i18n } from "@/plugin/i18n";
import { PostOfficeService } from "@/services/post.office/post.office.services";

const ZipMixins = {
  methods: {
    zipcode: function (form) {
      const vm = this;

      if (!form) {
        form = vm.ruleForm;
      }

      const zipcode = form.cep ? form.cep : form.zipcode ? form.zipcode : null;

      if (!zipcode) {
        return false;
      }
      console.log("zip zip", zipcode);
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      PostOfficeService.zipcode(zipcode)
        .then((response) => {
          form.address = response.end;
          form.city = response.cidade;
          form.state = response.uf;
          form.neighborhood = response.bairro;
        })
        .catch(() => {
          vm.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
          });
        })
        .finally(() => loading.close());
    },
  },
};

export default ZipMixins;
